import { render, staticRenderFns } from "./DetailExceedPop.vue?vue&type=template&id=040ae3a8&scoped=true&"
import script from "./DetailExceedPop.vue?vue&type=script&lang=js&"
export * from "./DetailExceedPop.vue?vue&type=script&lang=js&"
import style0 from "./DetailExceedPop.vue?vue&type=style&index=0&id=040ae3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ae3a8",
  null
  
)

export default component.exports